import { useContext } from 'react';

import { GlobalContext } from '@/context/global-context';
import { Discipline } from '@/services/disciplines.service';

export default function useDisciplines(): Discipline[] {
  const { pageStaticData } = useContext(GlobalContext);

  return pageStaticData?.disciplines || [];
}
